/**
 * onboardingSteps.ts / signupOpen.ts の知らせる関数を API につないだもの（2026-10-18 ops/gaps-activity）。
 * WHY 別のファイルか: api.ts は import.meta.env を読む = node のテストから読み込めない。純関数（と、そのテスト）は向こうに置き、ここは 2 行だけ。
 * どちらもモジュールの変数 = 1 画面の読み込み（ページの再読み込みまで）につき 1 回。
 */
import { api } from './api';
import { createStepReporter, ONBOARDING_STEP_PATH } from './onboardingSteps';
import { createSignupOpenReporter, SIGNUP_OPEN_PATH } from './signupOpen';

export const reportOnboardingStep = createStepReporter((step) => api(ONBOARDING_STEP_PATH, { method: 'POST', body: { step } }));

// auth: false = 登録の画面はログインしていない（トークンを付けない・401 でログイン画面へ戻す仕組みにも触れない）
export const reportSignupOpen = createSignupOpenReporter((body) => api(SIGNUP_OPEN_PATH, { method: 'POST', body, auth: false }));
